import { PageTitle } from "../../misc/PageTitle";
import { DatagridConfigurable, List, TextField } from "react-admin";
import { EmptyState } from "../../misc/EmptyState";
import { DateField } from "../../fields/DateField";
import { useAutovioContext } from "../../hooks/useAutovioContext";
import { MoneyField } from "../../fields/MoneyField";

export function DrivingSchoolManualRefunds() {
  const [{ drivingSchoolId }] = useAutovioContext();
  return (
    <>
      <PageTitle>Manuelle Erstattungen</PageTitle>
      <List
        resource={"manualRefunds"}
        title=" " // <-- prevent that the default list title is rendered
        filter={{ drivingSchoolId }}
        sort={/* initial sort order: */ { field: "created_at", order: "DESC" }}
        empty={<EmptyState noEntriesText="Noch keine manuelle Erstattung vorhanden." />}
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          empty={
            <EmptyState
              noEntriesText="Noch keine manuelle Erstattung vorhanden."
              noMatchingEntriesText="Keine passenden manuellen Erstattungen gefunden."
            />
          }
        >
          <TextField source="company_name" label="Fahrschule" />
          <TextField source="prepaid_invoice_number" label="Rechnung" />
          <MoneyField source="refund_amount" label="Betrag" />
          <TextField source="user_email" label="Fahrschüler ID" />
          <DateField source="created_at" label="Erstellt am" />
          <MoneyField
            source="hq_give_back_to_partner"
            label={"Anteilig von Autovio er\u00ADstat\u00ADtet an Fahr\u00ADschule"}
          />
        </DatagridConfigurable>
      </List>
    </>
  );
}
